import styled from "styled-components";

import PageTopTitle from "../../../components/shared/PageTopTitle";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import {
  getSigortaAranacakNumara,
  getSigortaTeklifleri,
} from "../../../features/sigorta/sigortaSlice";
import InputGroupPhoneNumber from "../../../components/shared/InputGroupPhoneNumber";
import InputGroupDate from "../../../components/shared/InputGroupDate";
import { sigortaDurumOptions } from "../../../utils/sigortaListesiOptions";
import SingleInputSelect from "../../../components/shared/SingleInputSelect";
import Pagination from "../../../components/shared/Pagination";
import Button from "../../../components/shared/button/Btn";
import { useNavigate } from "react-router-dom";
import SigortaListesiContainer from "../../../components/adminContainers/SigortaListesiContainer";
import { showModal } from "../../../features/modal/modalSlice";

const Container = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .content {
      gap: 60px;
      margin: 0 30px;
      margin-top: 20px;
      @media (max-width: 1550px) {
        margin: 0;
        padding: 20px 30px 0px;
        overflow: auto;
        width: 100%;
      }
      .titles {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: center;
        padding-inline: 10px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
        p{
          text-align: center;
          width: 150px;
        }
      }
      .page-top-container {
        margin: 20px 0;
        width: 100%;
        display: flex;
        justify-content: space-between;
        @media (max-width: 1550px) {
        }
        .btn-container {
          display: flex;
          gap: 30px;
          @media (max-width: 1550px) {
            flex-wrap: wrap;
            gap: 20px;
          }
        }
      }

      .top-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 20px 0 25px;

        .side {
          display: flex;
          gap: 20px;
        }
      }
    }

    .pagination-container {
      gap: 60px;
      margin: 0 30px;
      margin-top: 20px;
      height: 200px;
    }
  }
`;


const titles = [
  "Ad Soyad",
  "Kaydedilen Cep Telefonu",
  "Aranacak Cep Telefonu",
  "Sigorta Türü",
  "Araç Plakası",
  "Araç Türü",
  "Model Yılı",
  "RS TC No",
  "Ruhsat Seri No",
  "Kasko Değeri",
  "IMM Değeri",
  "Kayıt Tarihi",
  "Sonuç",
];

const SigortaListesi = () => {
  const { sigortaList, sigortaCount, sigortaAranacakNumara } = useSelector(
    (state) => state.sigorta
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState(sigortaAranacakNumara);

  const [kayitBaslangicTarihi, setKayitBaslangicTarihi] = useState("");
  const [KayitBitisTarihi, setKayitBitisTarihi] = useState("");
  const [status, setStatus] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(sigortaCount / itemsPerPage);

  useEffect(() => {
    dispatch(getSigortaAranacakNumara());
  }, []);

  useEffect(() => {
    dispatch(getSigortaTeklifleri(currentPage));
  }, [currentPage]);

  useEffect(() => {
    if (sigortaAranacakNumara) {
      setPhoneNumber(sigortaAranacakNumara);
    }
  }, [sigortaAranacakNumara]);

  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle title={"Sigorta Listesi"} position="sticky" />
        <div className="content">
          <div className="page-top-container">
            <div className="btn-container">
              <Button
                type="button"
                color={"#E85546"} background={"#fff"}
                handleClick={() => navigate("/admin/sigorta-listesi")}
                padding="0 10px"
                width="260px"
              >Sigorta Listesi</Button>
              <Button
                type="button"
                color={"#E85546"} 
                background={"#fff"}
                handleClick={() => {}}
                padding="0 10px"
                width="260px"
              >Sigorta Talepleri</Button>
              <Button
                type="button"
                color={"#E85546"} 
                background={"#fff"}
                handleClick={() => dispatch(showModal("sigortaReklamGorsel"))}
                padding="0 10px"
                width="260px"
              >Reklam Görseli</Button>
              <Button
                type="button"
                color={"#E85546"} 
                background={"#fff"}
                handleClick={() => {}}
                padding="0 10px"
                width="260px"
              >Sigorta Raporları</Button>
            </div>
            <div className="btn-container">
              <Button
                type="button"
                color={"#E85546"} 
                background={"#fff"}
                handleClick={() => {}}
                padding="0 10px"
                width="260px"
              >Ayarlar</Button>
            </div>
          </div>
          <div className="top-container">
            <div className="side">
              <InputGroupPhoneNumber
                name={"phoneNumber"}
                value={phoneNumber}
                labelText="Sigorta Telefon Numarası"
                requiredFields={[]}
                handleChange={setPhoneNumber}
                labelWidth={"210px"}
                inputWidth={"180px"}
              />
            </div>

            <div className="side">
              <InputGroupDate
                handleChange={(e) => setKayitBaslangicTarihi(e.target.value)}
                isRequired={false}
                labelText={"Kayıt Başlangıç Tarihi"}
                value={kayitBaslangicTarihi}
                inputType={"date"}
                name={"kayitBaslangicTarihi"}
                labelWidth={"180px"}
                inputWidth={"180px"}
                isSubmitted={false}
                requiredFields={[]}
              />
              <InputGroupDate
                handleChange={(e) => setKayitBitisTarihi(e.target.value)}
                isRequired={false}
                labelText={"Kayıt Bitiş Tarihi"}
                value={KayitBitisTarihi}
                inputType={"date"}
                name={"KayitBitisTarihi"}
                labelWidth={"180px"}
                inputWidth={"180px"}
                isSubmitted={false}
                requiredFields={[]}
              />
              <SingleInputSelect
                value={status}
                handleChange={setStatus}
                options={sigortaDurumOptions}
                name={"status"}
                width={"180px"}
                placeholder="Durum"
              />
            </div>
          </div>
          <div className="titles">
            {titles.map((item) => (
              <p>{item}</p>
            ))}
          </div>
          {sigortaList?.map((item)=>(
            <SigortaListesiContainer data={item} />
          ))}
          {/* <Table
            titles={titles}
            data={sigortaList}
            type={"sigortaList"}
            eventQuantity={1}
            errMessage={"Seferde olan herhangi bir yük yok"}
          /> */}
        </div>
        {(sigortaList || sigortaList?.length > 0) && (
          <Pagination
            totalPages={totalPages}
            handleClick={setCurrentPage}
            currentPage={currentPage}
          />
        )}
      </div>
    </Container>
  );
};

export default SigortaListesi;
